package com.merkost.handpass.api.dto

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class ApiError(
    val code: String,
    val message: String,
    @SerialName("request_id") val requestId: String? = null,
    val timestamp: String? = null,
    val details: Map<String, String>? = null,
    val fields: List<FieldError>? = null
)
